import React from 'react';

const Rocket = () => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8059 29.9024L22.1846 22.0274C19.0556 21.2369 15.7908 21.1447 12.6221 21.7574C9.11214 22.6236 8.56089 29.2499 8.50464 32.3886C8.50072 32.5628 8.54337 32.7349 8.6282 32.8872C8.71303 33.0394 8.83696 33.1662 8.98718 33.2545C9.1374 33.3428 9.30848 33.3894 9.48273 33.3894C9.65698 33.3895 9.82809 33.3431 9.97839 33.2549L15.8059 29.9024Z"
        fill="#FF6242"
      />
      <path
        d="M12.6452 24.7501C15.0978 24.2456 17.6222 24.1961 20.0927 24.6039L22.1852 22.0389C19.0561 21.2483 15.7914 21.1562 12.6227 21.7689C9.11273 22.6239 8.56148 29.2501 8.50523 32.3889C8.50241 32.5806 8.55728 32.7687 8.66273 32.9289C9.00023 29.6214 9.88898 25.4364 12.6452 24.7501Z"
        fill="#FF866E"
      />
      <path
        d="M15.8059 29.9024L22.1846 22.0274C19.0556 21.2369 15.7908 21.1447 12.6221 21.7574C9.11214 22.6236 8.56089 29.2499 8.50464 32.3886C8.50072 32.5628 8.54337 32.7349 8.6282 32.8872C8.71303 33.0394 8.83696 33.1662 8.98718 33.2545C9.1374 33.3428 9.30848 33.3894 9.48273 33.3894C9.65698 33.3895 9.82809 33.3431 9.97839 33.2549L15.8059 29.9024Z"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.4674 37.575L31.3424 31.1963C32.1324 34.3216 32.2246 37.5826 31.6124 40.7475C30.7912 44.2575 24.2099 44.8088 21.0262 44.865C20.852 44.869 20.6799 44.8263 20.5277 44.7415C20.3755 44.6567 20.2487 44.5327 20.1604 44.3825C20.0721 44.2323 20.0255 44.0612 20.0254 43.887C20.0253 43.7127 20.0718 43.5416 20.1599 43.3913L23.4674 37.575Z"
        fill="#FF6242"
      />
      <path
        d="M28.5862 40.7363C29.0964 38.2806 29.146 35.7514 28.7324 33.2775L31.2974 31.1963C32.0874 34.3216 32.1795 37.5826 31.5674 40.7475C30.7462 44.2575 24.1649 44.8088 20.9812 44.865C20.7896 44.8665 20.6019 44.8117 20.4412 44.7075C23.7487 44.415 27.9337 43.4813 28.5862 40.7363Z"
        fill="#FF866E"
      />
      <path
        d="M23.4674 37.575L31.3424 31.1963C32.1324 34.3216 32.2246 37.5826 31.6124 40.7475C30.7912 44.2575 24.2099 44.8088 21.0262 44.865C20.852 44.869 20.6799 44.8263 20.5277 44.7415C20.3755 44.6567 20.2487 44.5327 20.1604 44.3825C20.0721 44.2323 20.0255 44.0612 20.0254 43.887C20.0253 43.7127 20.0718 43.5416 20.1599 43.3913L23.4674 37.575Z"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.415 24.2549C50.5125 17.8424 48.5887 9.93363 47.6325 7.15488C47.5228 6.82455 47.338 6.52417 47.0925 6.27738C46.8459 6.03725 46.5504 5.85307 46.2262 5.73738C43.4475 4.78113 35.5275 2.85738 29.115 8.99988C21.195 16.4924 15.75 29.8124 15.75 29.8124L23.625 37.6874C23.625 37.6874 36.8775 32.1749 44.415 24.2549Z"
        fill="#E8F4FA"
      />
      <path
        d="M31.5562 13.3536C37.7775 7.42488 45.405 9.07863 48.4312 10.0461C48.2582 9.06478 48.0099 8.09819 47.6887 7.15488C47.5736 6.82024 47.3812 6.51747 47.1271 6.27117C46.873 6.02488 46.5643 5.84199 46.2262 5.73738C43.4475 4.78113 35.5275 2.85738 29.115 8.99988C21.195 16.4924 15.75 29.8124 15.75 29.8124L18.7763 32.8386C20.385 29.2499 25.1662 19.4286 31.5562 13.3536Z"
        fill="white"
      />
      <path
        d="M44.415 24.2549C50.5125 17.8424 48.5888 9.93363 47.6325 7.15488C47.5228 6.82455 47.338 6.52417 47.0925 6.27738C46.8459 6.03725 46.5504 5.85307 46.2263 5.73738C43.4475 4.78113 35.5275 2.85738 29.115 8.99988C21.195 16.4924 15.75 29.8124 15.75 29.8124L23.625 37.6874C23.625 37.6874 36.8775 32.1749 44.415 24.2549Z"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.15"
        d="M20.4978 49.7363C20.4978 50.1839 21.6831 50.6131 23.7929 50.9296C25.9026 51.246 28.7641 51.4238 31.7478 51.4238C34.7315 51.4238 37.593 51.246 39.7028 50.9296C41.8125 50.6131 42.9978 50.1839 42.9978 49.7363C42.9978 49.2888 41.8125 48.8596 39.7028 48.5431C37.593 48.2266 34.7315 48.0488 31.7478 48.0488C28.7641 48.0488 25.9026 48.2266 23.7929 48.5431C21.6831 48.8596 20.4978 49.2888 20.4978 49.7363Z"
        fill="#45413C"
      />
      <path
        d="M25.5377 28.8563C25.6195 28.7114 25.6518 28.5438 25.6298 28.3788C25.6077 28.2139 25.5324 28.0606 25.4154 27.9423C25.2983 27.824 25.1459 27.7471 24.9812 27.7232C24.8165 27.6994 24.6485 27.7299 24.5027 27.8101C22.3111 28.9319 20.2979 30.3725 18.529 32.0851C16.6553 33.9724 15.1754 36.2133 14.1752 38.6776C14.1451 38.7473 14.1364 38.8244 14.1502 38.899C14.164 38.9737 14.1997 39.0426 14.2528 39.0969C14.3059 39.1512 14.3739 39.1884 14.4483 39.2039C14.5226 39.2194 14.5999 39.2124 14.6702 39.1838C17.1307 38.1971 19.3714 36.7326 21.2627 34.8751C22.9818 33.0948 24.423 31.0658 25.5377 28.8563Z"
        fill="#FF6242"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.7703 15.435C31.7703 17.0731 32.421 18.644 33.5792 19.8023C34.7375 20.9606 36.3085 21.6113 37.9465 21.6113C39.5846 21.6113 41.1555 20.9606 42.3138 19.8023C43.4721 18.644 44.1228 17.0731 44.1228 15.435C44.1228 13.797 43.4721 12.226 42.3138 11.0678C41.1555 9.9095 39.5846 9.25879 37.9465 9.25879C36.3085 9.25879 34.7375 9.9095 33.5792 11.0678C32.421 12.226 31.7703 13.797 31.7703 15.435Z"
        fill="#C0DCEB"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.7051 15.4015C33.7051 15.9629 33.8157 16.5188 34.0305 17.0374C34.2453 17.5561 34.5602 18.0274 34.9572 18.4243C35.3542 18.8213 35.8254 19.1362 36.3441 19.3511C36.8628 19.5659 37.4187 19.6765 37.9801 19.6765C38.5415 19.6765 39.0974 19.5659 39.616 19.3511C40.1347 19.1362 40.606 18.8213 41.003 18.4243C41.3999 18.0274 41.7148 17.5561 41.9297 17.0374C42.1445 16.5188 42.2551 15.9629 42.2551 15.4015C42.2551 14.8401 42.1445 14.2842 41.9297 13.7655C41.7148 13.2468 41.3999 12.7756 41.003 12.3786C40.606 11.9816 40.1347 11.6667 39.616 11.4519C39.0974 11.237 38.5415 11.1265 37.9801 11.1265C37.4187 11.1265 36.8628 11.237 36.3441 11.4519C35.8254 11.6667 35.3542 11.9816 34.9572 12.3786C34.5602 12.7756 34.2453 13.2468 34.0305 13.7655C33.8157 14.2842 33.7051 14.8401 33.7051 15.4015Z"
        fill="#00B8F0"
      />
      <path
        d="M34.9537 12.3749C34.5558 12.772 34.24 13.2437 34.0246 13.763C33.8091 14.2823 33.6982 14.8389 33.6982 15.4011C33.6982 15.9633 33.8091 16.52 34.0246 17.0393C34.24 17.5586 34.5558 18.0303 34.9537 18.4274C35.2399 18.7016 35.5615 18.9362 35.91 19.1249L39.9037 11.5986C39.1032 11.1856 38.1918 11.0381 37.3019 11.1777C36.4119 11.3172 35.5894 11.7366 34.9537 12.3749Z"
        fill="#4ACFFF"
      />
      <path
        d="M33.7051 15.4015C33.7051 15.9629 33.8157 16.5188 34.0305 17.0374C34.2453 17.5561 34.5602 18.0274 34.9572 18.4243C35.3542 18.8213 35.8254 19.1362 36.3441 19.3511C36.8628 19.5659 37.4187 19.6765 37.9801 19.6765C38.5415 19.6765 39.0974 19.5659 39.616 19.3511C40.1347 19.1362 40.606 18.8213 41.003 18.4243C41.3999 18.0274 41.7148 17.5561 41.9297 17.0374C42.1445 16.5188 42.2551 15.9629 42.2551 15.4015C42.2551 14.8401 42.1445 14.2842 41.9297 13.7655C41.7148 13.2468 41.3999 12.7756 41.003 12.3786C40.606 11.9816 40.1347 11.6667 39.616 11.4519C39.0974 11.237 38.5415 11.1265 37.9801 11.1265C37.4187 11.1265 36.8628 11.237 36.3441 11.4519C35.8254 11.6667 35.3542 11.9816 34.9572 12.3786C34.5602 12.7756 34.2453 13.2468 34.0305 13.7655C33.8157 14.2842 33.7051 14.8401 33.7051 15.4015Z"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7576 46.6537C11.9701 47.4412 6.95262 49.1399 4.41012 49.9612C3.93762 50.1187 3.28512 49.4324 3.40887 48.9599C4.23012 46.4287 5.92888 41.4112 6.78388 40.6124C7.85263 39.4874 10.6426 39.4874 12.3076 41.1299C13.9726 42.7724 13.8264 45.5849 12.7576 46.6537Z"
        fill="#FF8A14"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3963 44.7637C10.8338 45.3149 8.50504 45.8887 8.02129 45.3937C7.53754 44.8987 8.10004 42.5362 8.66254 42.0187C9.03522 41.7643 9.49115 41.6621 9.93675 41.7333C10.3823 41.8044 10.7838 42.0434 11.0588 42.4012C11.4025 42.6799 11.6283 43.0781 11.6909 43.5162C11.7535 43.9543 11.6483 44.3999 11.3963 44.7637Z"
        fill="#FFE500"
        stroke="#45413C"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Rocket;
